/**
 * @module FE-CU09_表示地区詳細画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import TabHeader from '../../components/tabHeader/TabHeader.vue';
import SecurityNotification from '../../components/securityNotification/SecurityNotification.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NotificationHistoryTimeline from '../../components/NotificationHistoryTimeline/NotificationHistoryTimeline.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU09';

export default {
  name: 'AddressDetail',
  components: {
    Header,
    BreadCrumbList,
    MobileFooter,
    ListPanel,
    TabHeader,
    SecurityNotification,
    PcPageTitle,
    PCFooter,
    NotificationHistoryTimeline,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区詳細'),
      firstText: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.ホームセキュリティ'),
      displayName: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区詳細'),
      displayAreaPanelTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      displayAreaList: [],
      userType: 1,

      warningOccurred: '',
      lockUp: '',
      securityStatus: '',
      notificationImage: require('../../assets/images/icon/notification.png'),
      isAlert: true,
      isLockUp: false,
      securityImage: require('../../assets/images/camera/security.png'),
      personImage: require('../../assets/images/camera/person.png'),
      messageImage: require('../../assets/images/camera/message.png'),
      callingImage: require('../../assets/images/camera/calling.png'),
      settingImage: require('../../assets/images/camera/setting.png'),
      equipmentSettingImage: require('../../assets/images/camera/equipmentSetting.png'),
      userSecurityOperationAuthority0901: false,
      userSecurityOperationAuthority1001: false,
      rushOrderAuthority: false,
      notificationHistoryAuthority: false,
      contactAuthority: false,
      deviceContorolAuthority: false,
      //displayDistrictSettingAuthority: false,
      displayDistrictSettingAuthority: true, // #29840[機能修正管理表No.62] 各種設定ボタンが増えたので常に表示
      tabNumber: null,
      tabs: [
        {
          id: 1,
          title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区メニュー'),
        },
        {
          id: 2,
          title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.通知履歴24時間以内'),
        },
      ],
      lastUpdate: '',
      // 通知履歴一覧を格納
      notificationList: [],
      notificationCount: 0,
      notificationColor: '',
      securityUnitExecutionResults: [],
      CONSTANTS: CONSTANTS,
      disabledFlagArray: [],
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区詳細'),
        firstText: vm.$vuetify.lang.t('$vuetify.FECU08ホームセキュリティ画面.ホームセキュリティ'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU09対象地区詳細画面.C0001'),
        displayName: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区詳細'),
        tabs: [
          {
            id: 1,
            title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.対象地区メニュー'),
          },
          {
            id: 2,
            title: vm.$vuetify.lang.t('$vuetify.FECU09対象地区詳細画面.通知履歴24時間以内'),
          },
        ],
      };
    },
    /**
     * ユーザー警備操作ボタン 表示制御
     */
    userSecurityOperationAuthority() {
      return this.userSecurityOperationAuthority0901 || this.userSecurityOperationAuthority1001
        ? true
        : false;
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期化処理
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     */
    init: async function (queries, method) {
      // let param = "post"; // 検証用

      let param = '/api/common/getRoleList'; // 本番用
      await this.APP_CU9916(param, queries, method);

      param = '/api/displayDistrictDetail/init';
      let queries0901 = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        isSendCommand: true,
      };
      // 各種APIでデータを取得
      const ret09 = await this.APP_CU0901(param, queries0901, method);

      // SecurityNotification用START
      // ユーザー権限を設定
      this.userType = Number(ret09.contentsInfo.displayDistrictAuthority.displayDistrictUserType); // 暗黙的型変換
      this.notificationCount = ret09.contentsInfo.displayDistrictSecurityStatus.notificationCount;
      let color = 'blue';
      ret09.contentsInfo.displayDistrictSecurityStatus.serviceTypeList.some(function (service) {
        let serviceColor =
          CONSTANTS.NOTIFICATION_HISTORY.CONTENTS_TYPE1.SERVICE_TYPE[service.serviceType] ?? 'blue';
        if (serviceColor === 'red') {
          color = serviceColor;
          return true;
        } else if (serviceColor === 'yellow') {
          color = serviceColor;
        }
      });
      this.notificationColor = color;
      // SecurityNotification用END

      // <通知履歴メニュー>
      this.lastUpdate = ret09.contentsInfo.notificationInfo.lastUpdate.replace(/-/g, '/');
      let allNotificationList = ret09.contentsInfo.notificationInfo.notificationList;

      let check1901 = false;
      let check1001 = false;
      this.disabledFlagArray.map((auth) => {
        if (
          auth.customerNumber == this.$store.state.customerNumber &&
          auth.districtSplitNumber == this.$store.state.districtSplitNumber
        ) {
          check1901 = auth.check1901;
          check1001 = auth.check1001;
        }
      });
      let ret1901 = '';
      if (check1901) {
        param = '/api/displayDistrictSettings/init';
        ret1901 = await this.APP_CU1901(param, queries, method);
      }

      // ボタンの表示/非表示を設定
      const ret0901Authority = ret09.contentsInfo.displayDistrictAuthority;
      let ret1901Authority = {
        nicknameSetting: false,
        IDCardKeyInfoSetting: false,
        notificationDeliverySetting: false,
        watchOverInfoDeliverySetting: false,
        securityOperation: false,
      };
      if (ret1901.contentsInfo) {
        ret1901Authority = ret1901.contentsInfo.displayDistrictAuthority;
      }

      if (check1001) {
        param = '/api/userSecurityOperation/init';
        let queries1001 = {
          token: sessionStorage.getItem('token'),
          terminalInfo: localStorage.getItem('terminalInfo')
            ? localStorage.getItem('terminalInfo')
            : '',
          customerNumber: this.$store.state.customerNumber,
          districtSplitNumber: this.$store.state.districtSplitNumber,
          isSendCommand: false,
        };

        const ret1001Authority = await this.APP_CU1001(param, queries1001, method);
        if (ret1001Authority) {
          // 詳細は【 コチラ 】の表示制御を設定
          allNotificationList.map((notification) => {
            notification.warningCheck =
              ret1001Authority.contentsInfo.screenDisplayInfo.warningCheck;
          });
        }
      }

      let onlyOnce = false;
      allNotificationList.forEach((list) => {
        // 前回ログイン以降の通知 を表示
        if (!onlyOnce && list.isNewMessageLabel) {
          list.newMessageFromHere = true;
          onlyOnce = true;
        }
      });
      this.notificationList = allNotificationList;

      // かけつけ依頼ボタン
      if (
        ret09.contentsInfo.displayDistrictInfo.usagePlan ==
          CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN ||
        ret09.contentsInfo.displayDistrictInfo.usagePlan ==
          CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN
      ) {
        this.rushOrderAuthority = ret0901Authority.rushOrderAuthority;
      } else {
        this.rushOrderAuthority = false;
      }
      // 通知履歴ボタン
      this.notificationHistoryAuthority = ret0901Authority.notificationHistory;
      // ALSOKへのお問い合わせボタン
      this.contactAuthority = ret0901Authority.contactAuthority;
      // 表示地区設定ボタン
      if (
        ret1901Authority.nicknameSetting ||
        ret1901Authority.IDCardKeyInfoSetting ||
        ret1901Authority.notificationDeliverySetting ||
        ret1901Authority.watchOverInfoDeliverySetting
      ) {
        this.displayDistrictSettingAuthority = true;
      }

      // 機器制御ボタン
      this.deviceContorolAuthority = ret0901Authority.deviceContorolAuthority;

      // 警備ユニットコマンド事項結果確認API
      this.$store.commit('requestApi/setInterruptionFlag', false);
      let promiseList = [];
      this.securityUnitExecutionResults = [];
      const securityParams = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        sendCustomerNumber: ret09.contentsInfo.unitCommandInfo[0].sendCustomerNumber,
        sendCommandKey: ret09.contentsInfo.unitCommandInfo[0].sendCommandKey,
        apiId: 2, // APP_CU0901
        alarmType: 0, // 本画面では必須ではないため0で埋める
        districtSplitNumber: '', // 本画面では必須ではないため空で埋める
        securityAreaId: '', // 本画面では必須ではないため空で埋める
      };
      promiseList.push(this.APP_CO9915_Security(securityParams));

      const lockUpParams = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        sendCustomerNumber: ret09.contentsInfo.unitCommandInfo[0].sendCustomerNumber,
        sendCommandKey: ret09.contentsInfo.unitCommandInfo[1].sendCommandKey,
        apiId: 2, // APP_CU0901
        alarmType: 0, // 本画面では必須ではないため0で埋める
        districtSplitNumber: '', // 本画面では必須ではないため空で埋める
        securityAreaId: '', // 本画面では必須ではないため空で埋める
      };
      promiseList.push(this.APP_CO9915_LockUp(lockUpParams));

      await Promise.all(promiseList);

      if (this.$store.getters[`requestApi/getInterruptionFlag`]) {
        if (this.securityUnitExecutionResults.length != 0) {
          this.$store.commit('requestApi/setInterruptionFlag', false);
          this.$_securityUnitExecutionResultsDialog(this.securityUnitExecutionResults);
        } else {
          this.$store.commit('requestApi/setInterruptionFlag', false);
          this.$errorDialog('$vuetify.メッセージ一覧.FECU09対象地区詳細画面.E0003');
        }
      }
    },
    /**
     * ユーザー権限一覧取得(APP_CU9916)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU9916: async function (param, queries, method) {
      let apiData = '';

      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: [
            //       {
            //         customerNumber: "1111111",
            //         districtSplitNumber: "1111111",
            //         displayDistrictUserType: 1,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           deviceContorol: true,
            //           contact: true,
            //           nicknameSetting: true,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: true,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: true,
            //           userManagement: true,
            //           emergencyContact: true,
            //         },
            //       },
            //       {
            //         customerNumber: "2222222",
            //         districtSplitNumber: "2222222",
            //         displayDistrictUserType: 2,
            //         userAuthority: {
            //           securityOperation: true,
            //           rushOrder: false,
            //           notificationHistory: true,
            //           deviceContorol: false,
            //           contact: true,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: true,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: true,
            //           targetAtHomeSetting: false,
            //           userManagement: true,
            //           emergencyContact: false,
            //         },
            //       },
            //       {
            //         customerNumber: "3333333",
            //         districtSplitNumber: "3333333",
            //         displayDistrictUserType: 2,
            //         userAuthority: {
            //           securityOperation: false,
            //           rushOrder: false,
            //           notificationHistory: false,
            //           deviceContorol: false,
            //           contact: false,
            //           nicknameSetting: false,
            //           IDCardKeyInfoSetting: false,
            //           watchOverInfoDeliverySetting: false,
            //           lockUpCheck: false,
            //           targetAtHomeSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         customerNumber: "customerNumber",
            //         districtSplitNumber: "1",
            //         deviceID: "1111",
            //         cameraUserType: 1,
            //         userAuthority: {
            //           anticrimeCameraVideos: true,
            //           rushOrder: true,
            //           notificationHistory: true,
            //           contact: true,
            //           nicknameSetting: false,
            //           userManagement: false,
            //           emergencyContact: false,
            //         },
            //       },
            //     ],
            //   },
            // };

            for (let i = 0; i < apiData.contentsInfo.displayDistrictInfoList.length; i++) {
              let userAuthority = apiData.contentsInfo.displayDistrictInfoList[i].userAuthority;
              let check1901 =
                userAuthority.securityOperation ||
                userAuthority.nicknameSetting ||
                userAuthority.IDCardKeyInfoSetting ||
                userAuthority.watchOverInfoDeliverySetting ||
                userAuthority.notificationHistory;
              let check1001 =
                userAuthority.securityOperation ||
                userAuthority.lockUpCheck ||
                userAuthority.targetAtHomeSetting;
              let auth = {
                displayDistrictUserType: '',
                customerNumber: '',
                districtSplitNumber: '',
                check1901: check1901,
                check1001: check1001,
              };
              auth.customerNumber = apiData.contentsInfo.displayDistrictInfoList[i].customerNumber;
              auth.districtSplitNumber =
                apiData.contentsInfo.displayDistrictInfoList[i].districtSplitNumber;
              auth.displayDistrictUserType =
                apiData.contentsInfo.displayDistrictInfoList[i].displayDistrictUserType;
              this.disabledFlagArray[i] = auth;
            }
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        );
      return apiData;
    },
    /**
     * 初期表示(APP_CU0901)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU0901: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfoList: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1234",
            //       displayDistrictNickname: "自宅",
            //     },
            //     displayDistrictSecurityStatus: {
            //       notificationCount: 3,
            //       serviceTypeList: [
            //         { serviceType: "A01" },
            //         { serviceType: "A02" },
            //         { serviceType: "A03" },
            //       ],
            //     },
            //     displayDistrictAuthority: {
            //       displayDistrictUserType: "1",
            //       userSecurityOperationAuthority: false,
            //       rushOrderAuthority: false,
            //       notificationHistory: false,
            //       contactAuthority: false,
            //       deviceContorolAuthority: false,
            //     },
            //     notificationInfo: {
            //       lastUpdate: "2022-05-30 18:00:00",
            //       notificationList: [
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 01:00:00",
            //           contentType: 1,
            //           serviceType: "N01",
            //           customerNumber: "11111-11111",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "リビングセンサー",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-01 06:00:00",
            //           contentType: 1,
            //           serviceType: "A10",
            //           customerNumber: "22222-22222",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "玄関センサー",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: false,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "綜警 太郎",
            //           postedDatetime: "2022-05-20 12:00:00",
            //           contentType: 0,
            //           serviceType: "S05",
            //           customerNumber: "33333-33333",
            //           operatorInfo: "綜警 太郎",
            //           sensorName: "玄関戸締り",
            //           securityDestinationName: "自宅",
            //           isPersonNotification: true,
            //         },
            //         {
            //           notificationType: 1,
            //           postedName: "HOME ALSOK",
            //           postedDatetime: "2022-05-30 20:00:00",
            //           contentType: 0,
            //           serviceType: "J07",
            //           customerNumber: "44444-44444",
            //           operatorInfo: "HOME ALSOK",
            //           sensorName: "浴室見守り",
            //           securityDestinationName: "祖父母宅",
            //           isPersonNotification: false,
            //         },
            //       ],
            //     },
            //     unitCommandInfo: [
            //       {
            //         sendCustomerNumber: "1111",
            //         sendCommandKey: "1111",
            //       },
            //     ],
            //   },
            // };

            // 取得したデータを元に画面表示を設定
            // < 対象地区メニュー >
            // ListPanel用START
            const targetItem = apiData.contentsInfo.displayDistrictInfo;
            const labels = {
              usagePlan: '$vuetify.FECU09対象地区詳細画面.対象地区詳細表示領域.利用プラン',
              customerNumber: '$vuetify.FECU09対象地区詳細画面.対象地区詳細表示領域.お客様番号',
              securityDestinationName:
                '$vuetify.FECU09対象地区詳細画面.対象地区詳細表示領域.警備先名',
              districtSplitNumber: '$vuetify.FECU09対象地区詳細画面.対象地区詳細表示領域.地区番号',
              districtSplitName: '$vuetify.FECU09対象地区詳細画面.対象地区詳細表示領域.地区名',
            };
            const targetKeys = [
              'usagePlan',
              'customerNumber',
              'securityDestinationName',
              'districtSplitNumber',
              'districtSplitName',
            ];
            const planTitles = {
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.オンライン監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.依頼かけつけプラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
              [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
                '$vuetify.コード.利用プランID.セルフ監視プラン',
            };
            Object.keys(targetItem).map((key, index) => {
              if (targetKeys.includes(key)) {
                let text = targetItem[key];
                if (key === 'usagePlan') {
                  text = planTitles[targetItem[key]];
                }
                if (key === 'districtSplitNumber') {
                  if (targetItem[key] === '') {
                    return;
                  }
                  if (targetItem[key] === '    ') {
                    text = '$vuetify.FECU09対象地区詳細画面.メイン地区';
                  }
                }
                this.displayAreaList = [
                  ...this.displayAreaList,
                  {
                    id: index,
                    title: labels[key],
                    text: text,
                    isVuetifyKey: text.includes('$'),
                  },
                ];
              }
            });
            this.displayAreaPanelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU09対象地区詳細画面.対象地区',
              typeIsBefore: true,
            };

            this.userSecurityOperationAuthority0901 =
              apiData.contentsInfo.displayDistrictAuthority.userSecurityOperationAuthority;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU0901に対する警備状態読み出しの警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} queries リクエストのパラメータ
     */
    APP_CO9915_Security: async function (queries) {
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: queries,
        })
        .then((response /* eslint-disable-line */) => {
          // response = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu0901: {
          //         forSecurityStatus: {
          //           securityStatus: "M",
          //         },
          //       },
          //     },
          //   },
          // };
          if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult == 0
          ) {
            // 警備状態を設定
            switch (
              response.contentsInfo.commandExecutionResult.app_cu0901.forSecurityStatus
                .securityStatus
            ) {
              case 'N':
                this.securityStatus =
                  '$vuetify.FECU09対象地区詳細画面.警備状態データ.外出ALSOK警備中';
                break;
              case 'M':
                this.securityStatus =
                  '$vuetify.FECU09対象地区詳細画面.警備状態データ.在宅ALSOK警備中';
                break;
              case 'S':
                this.securityStatus =
                  '$vuetify.FECU09対象地区詳細画面.警備状態データ.外出セルフ警備中';
                break;
              case 'L':
                this.securityStatus =
                  '$vuetify.FECU09対象地区詳細画面.警備状態データ.在宅セルフ警備中';
                break;
              case 'F':
                this.securityStatus = '$vuetify.FECU09対象地区詳細画面.警備状態データ.警備解除中';
                break;
              case 'P':
                this.securityStatus = '$vuetify.FECU09対象地区詳細画面.警備状態データ.ユーザ点検中';
                break;
            }
          } else if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (response.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                response.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });
    },
    /**
     * APP_CU0901に対する戸締り確認読み出しの警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} queries リクエストのパラメータ
     */
    APP_CO9915_LockUp: async function (queries) {
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: queries,
        })
        .then((response /* eslint-disable-line */) => {
          // response = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu0901: {
          //         forLockUp: {
          //           warningOccurredFlg: false,
          //           lockUpFlg: false,
          //         },
          //       },
          //     },
          //   },
          // };
          if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult == 0
          ) {
            // 発報状態を設定(異常があればtrue)
            const warningOccurredFlg =
              response.contentsInfo.commandExecutionResult.app_cu0901.forLockUp.warningOccurredFlg;
            this.warningOccurred = warningOccurredFlg
              ? '$vuetify.FECU09対象地区詳細画面.発報状態.あり'
              : '$vuetify.FECU09対象地区詳細画面.発報状態.なし';
            this.isAlert = warningOccurredFlg;

            // 戸締まり状態を設定(異常があればtrue)
            const lockUpFlag =
              response.contentsInfo.commandExecutionResult.app_cu0901.forLockUp.lockUpFlg;
            this.lockUp = lockUpFlag
              ? '$vuetify.FECU09対象地区詳細画面.戸締まり状態.NG'
              : '$vuetify.FECU09対象地区詳細画面.戸締まり状態.OK';
            this.isLockUp = !lockUpFlag;
          } else if (
            typeof response.contentsInfo.securityUnitExecutionResult !== 'undefined' &&
            response.contentsInfo.securityUnitExecutionResult != 0
          ) {
            if (response.contentsInfo.securityUnitExecutionResult != -1) {
              this.securityUnitExecutionResults.push(
                response.contentsInfo.securityUnitExecutionResult
              );
            }
            if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
              this.$store.commit('requestApi/setInterruptionFlag', true);
            }
          } else if (!this.$store.getters[`requestApi/getInterruptionFlag`]) {
            this.$store.commit('requestApi/setInterruptionFlag', true);
          }
        });
    },
    /**
     * 表示地区設定データ取得(APP_CU1901)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1901: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       displayDistrictFacilityName: "自宅",
            //       usagePlanId: 1,
            //       customerNumber: "111",
            //       districtSplitName: "A地区",
            //       districtSplitNumber: "5",
            //     },
            //     displayDistrictAuthority: {
            //       nicknameSetting: true,
            //       IDCardKeyInfoSetting: true,
            //       notificationDeliverySetting: true,
            //       watchOverInfoDeliverySetting: true,
            //       securityOperation: true,
            //     },
            //   },
            // };
          },
          (error) => {
            if (error.message.includes('403')) {
              // 表示地区権限が全てfalseとして扱う
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * ユーザー警備操作データ取得(APP_CU1001)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1001: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            if (
              apiData.contentsInfo.screenDisplayInfo.warningCheck ||
              apiData.contentsInfo.screenDisplayInfo.lockUpCheck ||
              apiData.contentsInfo.screenDisplayInfo.targetAtHomeSetting
            ) {
              this.userSecurityOperationAuthority1001 = true;
            }
          },
          (error) => {
            if (error.message.includes('403')) {
              // 画面表示情報が全てfalseとして扱う
              // warningCheck = false;
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 通知履歴ボタン押下処理
     */
    goNotificationHistory: function () {
      this.$store.commit('setFromType', { fromType: 1 });
      this.$router.push('notificationHistory');
    },
    /**
     * 戻るボタン押下処理
     */
    clickBack: function () {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      if (this.$store.state.districtOneCountFlag) {
        // 表示地区が1地区の場合、表示地区詳細画面に遷移する。
        this.$router.push('/top');
      } else {
        // 表示地区が2地区以上の場合、ホームセキュリティ画面に遷移する。
        this.$router.push('/homeSecurity');
      }
    },
  },
  watch: {
    tabNumber(num) {
      this.$store.commit('setTargetAreaDetailTabNumber', { targetAreaDetailTabNumber: num });
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);
    this.tabNumber = this.$store.state.targetAreaDetailTabNumber;
    this.$store.state.currentDisplayType = 1;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    this.isShowPage = true;

    let method = 'post';
    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    await this.init(queries, method);
    this.$store.commit('setFromType', { fromType: 1 });
  },
};
